<template>
  <nuxt-link
    :to="to"
    class="box infoletter-teaser bg-white relative flex md:block hyphens-auto"
  >
    <div class="w-100 shrink-0 md:w-full hidden md:block">
      <MediaImage v-if="image" v-bind="image" :image-style="imageStyle" />
    </div>
    <div class="box-padding">
      <div
        v-if="category?.name"
        class="flex md:-ml-10 md:mb-20 lg:mb-30 absolute -bottom-10 left-10 md:-mt-[35px] lg:-mt-[45px] md:static"
      >
        <Tag
          class="!inline-block max-w-full pt-[6px] overflow-hidden whitespace-nowrap text-ellipsis"
          >{{ category?.name }}</Tag
        >
      </div>

      <h2 class="text-md md:text-lg lg:text-xl break-words">
        {{ teaserTitle || title }}
      </h2>
      <div class="font-medium uppercase text-xs md:text-base mt-10 md:my-20">
        <DrupalDateTime
          v-if="created && created.first"
          v-bind="created.first"
          class="mr-10"
        />
        <ArticleAuthors :authors="authors" />
      </div>
      <div v-if="lead" class="mt-20 hidden md:block text-base">
        <p class="line-clamp-5 overflow-hidden">
          {{ lead }}
        </p>
      </div>
    </div>
  </nuxt-link>
</template>

<script lang="ts" setup>
import type {
  ArticleTeaserArticleFragment,
  ArticleTeaserFragment,
  ArticleTeaserPressReleaseFragment,
} from '#graphql-operations'

type PropImage =
  | ArticleTeaserArticleFragment['image']
  | ArticleTeaserPressReleaseFragment['image']

const props = defineProps<{
  // eslint-disable-next-line vue/prop-name-casing
  __typename: ArticleTeaserFragment['__typename']
  id?: string
  title?: string
  teaserTitle?: string
  url?: ArticleTeaserFragment['url']
  lead?: string
  image?: PropImage
  authors?: ArticleTeaserPressReleaseFragment['authors']
  created?: ArticleTeaserPressReleaseFragment['created']
  tags?: ArticleTeaserArticleFragment['tags']
  category?: ArticleTeaserArticleFragment['category']
}>()

const to = computed(() => {
  return props.url?.path
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    sm: 370,
  },
})
</script>
